import { Switch, Route, useLocation} from 'react-router-dom'
import { ROUTE_PATH } from './constants'

import "./App.css"
import "../css/saltire.css"
import "../css/global-form-styles.css"
import "../css/input-field-group.css"
import "../css/date-fields.css"
import "../css/date-picker.css"
import "../css/checkboxes.css"
import "../css/panel.css"
import "../css/buttons.css"
import "../css/accordion.css"
import "../css/details.css"
import "../css/phase-banner.css"
import "../css/radio-button.css"
import "../css/select.css"
import "../css/slider.css"
import "../css/summary-block.css"
import "../css/toggle.css"
import "../css/supplimentary-page-styles.css"

import {PreloadedRoute} from "./PreloadedRoute"
import PrivacyNotice from "../container/AgencyLicence/PrivacyNotice"
import EligibilityConfirmation from "../container/AgencyLicence/EligibilityConfirmation"
import NotEligible from "../container/AgencyLicence/NotEligible"
import NsLogin from "../container/AgencyLicence/NsLogin"
import Welcome from "../container/AgencyLicence/Welcome"
import RJSCSearch from "../container/AgencyLicence/RJSCSearch"
import RJSCSearchResult from "../container/AgencyLicence/RJSCSearchResult"
import RJSCAdvanceSearchResult from "../container/AgencyLicence/RJSCAdvanceSearchResult"
import RJSCDetailReview from "../container/AgencyLicence/RJSCDetailReview"
import BusinessContactDetail from '../container/AgencyLicence/BusinessContactDetail'
import AddressForService from '../container/AgencyLicence/AddressForService'
import AddressForFinancialRecords from '../container/AgencyLicence/AddressForFinancialRecords'
import WorkHistoryDetails from '../container/AgencyLicence/WorkHistoryDetails'
import CriminalHistoryQuestion from '../container/AgencyLicence/CriminalHistoryQuestion'
import CriminalHistoryDetails from '../container/AgencyLicence/CriminalHistoryDetails'
import LicenceSuspensionQuestion from '../container/AgencyLicence/LicenceSuspensionQuestion'
import LicenceSuspensionDetails from '../container/AgencyLicence/LicenceSuspensionDetails'
import AdditionalBranchQuestion from '../container/AgencyLicence/AdditionalBranchQuestion'
import AdditionalBranchDetails from '../container/AgencyLicence/AdditionalBranchDetails'
import SupportingDocuments from '../container/AgencyLicence/SupportingDocuments'
import TrustAccount from '../container/AgencyLicence/TrustAccount'
import SuretyBond from '../container/AgencyLicence/SuretyBond'
import ApplicationReview from '../container/AgencyLicence/AgencyApplicationReview'
import LaunchPageCollectionAgency from '../container/AgencyLicence/LaunchPageCollectionAgency'
import LaunchPageDebtManagementAgency from '../container/AgencyLicence/LaunchPageDebtManagementAgency'
import LaunchPageCollector from '../container/AgencyLicence/LaunchPageCollector'
import LaunchPage from '../container/LaunchPage'
import CollectorBeforeStartConfirmation from '../container/AgentLicence/AgentBeforeStartConfirmation'
import CollectorDetails from '../container/AgentLicence/AgentDetails'
import AgentDetails from "../container/AgentLicence/AgentDetailsView"
import AdditionalCollectorQuestion from '../container/AgencyLicence/AdditionalCollectorQuestion'
import CollectorApplicationReview from '../container/AgentLicence/AgentApplicationReview'
import ConfirmBeforePayment from '../container/AgencyLicence/ConfirmBeforePayment'
import PaymentPreview from '../container/AgencyLicence/PaymentPreview'
import CollectorsReview from '../container/AgentLicence/CollectorsReview'
import ScrollToTop from "../container/ScrollToTop"
import ConfirmApplicationSubmission from '../container/AgencyLicence/ConfirmApplicationSubmission'
import BLTLoginPage from '../container/BLT/BLTLogin/BLTLogin'
import BLTHomePage from '../container/BLT/BLTHome/BLTHome'
import BLTReviewPage from '../container/BLT/BLTReview/BLTReview'
import BLTChangeReviewPage from '../container/BLT/BLTChangeReview/BLTChangeReview'
import BLTDecisionSummaryPage from '../container/BLT/BLTDecision/BLTDecisionSummary'
import BLTLicenceInformationPage from '../container/BLT/BLTInformation/BLTInformation'
import BLTHomeSearchPage from "../container/BLT/BLTHomeSearch/BLTHomeSearch"
import { addToGoogleDataLayer } from '../shared/const/utils';
import { useEffect } from 'react'
import CompanyTrademark from '../container/AgencyLicence/CompanyTrademark'
import AgencyChangeRequest from '../container/AgencyLicence/AgencyApplicationChangeRequest'


// Mortgage App
import {MortgageApp} from './MortgageApp'
import {LenderApp} from './LenderApp'
import { MortgageAdministratorApp } from './MortgageAdministratorApp.'
import RJSCDetailRenewReview from '../container/AgencyRenewal/RJSCDetailRenewReview'
import AgencyApplicationRenewalReview from '../container/AgencyRenewal/AgencyApplicationRenewalReview'
// Mortgage details list (public facing page)
import { MortgageDetailsApp } from './MortgageDetailsApp'
import BranchApplicationDetails from '../container/AgencyLicence/BranchApplicationDetails'
import BranchApplicationReview from '../container/AgencyLicence/BranchApplicationReview'
import {BranchApplicationPaymentConfirmation} from '../container/AgencyLicence/BranchApplicationPaymentConfirmation'
import BranchDetailsView from '../container/AgencyLicence/BranchDetailsView'
import { MortgageMainAgentApp } from './MortgageMainAgentApp'
import { MraRJSCEnterCompanyInfo } from '../container/MRA/MraRJSCEnterCompanyInfo'
import { MraRJSCEnterCompanyOfficals } from '../container/MRA/MraRJSCEnterCompanyOfficials'
import AgencyRJSCCompanyDetail from '../container/AgencyLicence/AgencyRJSCCompanyDetail'

function App() {
  const location  = useLocation();
  useEffect(() => {
    try {
      addToGoogleDataLayer(location.pathname, 'Business Licence', "en")
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [location.pathname])

  return (
    <div className="collectionServiceContainer">
      <ScrollToTop>
        <Switch>
          <Route exact={true} path={ROUTE_PATH.PRIVACY_NOTICE} component={PrivacyNotice} />
          <Route exact={true} path={ROUTE_PATH.LAUNCHPAGE_COLLECTION_AGENCY} component={LaunchPageCollectionAgency} />
          <Route exact={true} path={ROUTE_PATH.LAUNCHPAGE_DEBT_MANAGEMENT_AGENCY} component={LaunchPageDebtManagementAgency} />
          <Route exact={true} path={ROUTE_PATH.LAUNCHPAGE_COLLECTOR} component={LaunchPageCollector} />
          <Route exact={true} path={ROUTE_PATH.ELIGIBILITY_CONFIRMATION} component={EligibilityConfirmation} />
          <Route exact={true} path={ROUTE_PATH.NOT_ELIGIBLE} component={NotEligible} />
          <Route exact={true} path={ROUTE_PATH.NS_LOGIN} component={NsLogin} />
          
          <Route path={ROUTE_PATH.MRA_APP} component={MortgageApp} />
          <Route path={ROUTE_PATH.ML_APP} component={LenderApp} />
          <Route path={ROUTE_PATH.MA_APP} component={MortgageAdministratorApp} />
          <Route path={ROUTE_PATH.MRA_DETAILS} component={MortgageDetailsApp} />
          <Route path={ROUTE_PATH.PB_APP} component={MortgageMainAgentApp} />
          <Route path={ROUTE_PATH.CO_APP} component={MortgageMainAgentApp} />
          
          <PreloadedRoute exact={true} path={ROUTE_PATH.WELCOME} component={Welcome} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_SEARCH} component={RJSCSearch} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_COMPANY_DETAIL} component={AgencyRJSCCompanyDetail} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_COMPANY_INFO} component={MraRJSCEnterCompanyInfo} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_COMPANY_OFFICIALS} component={MraRJSCEnterCompanyOfficals} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_SEARCH_SELECT} component={RJSCSearchResult} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_OPERATING_NAME_SEARCH_SELECT} component={RJSCAdvanceSearchResult} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_DETAIL_REVIEW} component={RJSCDetailReview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.RJSC_DETAIL_RENEW_REVIEW} component={RJSCDetailRenewReview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.COMPANY_TRADEMARK} component={CompanyTrademark} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BUSINESS_CONTACT} component={BusinessContactDetail} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.ADDRESS_FOR_SERVICE} component={AddressForService} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.FINANCIAL_RECORDS_LOCATION} component={AddressForFinancialRecords} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.WORK_HISTORY_DETAILS} component={WorkHistoryDetails} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.CRIMINAL_HISTORY_QUESTION} component={CriminalHistoryQuestion} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.CRIMINAL_HISTORY_DETAILS} component={CriminalHistoryDetails} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.LICENCE_SUSPENSION_QUESTION} component={LicenceSuspensionQuestion} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.LICENCE_SUSPENSION_DETAILS} component={LicenceSuspensionDetails} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.ADDITIONAL_BRANCH_QUESTION} component={AdditionalBranchQuestion} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS} component={AdditionalBranchDetails} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.CURRENT_BRANCH_DETAILS} component={BranchDetailsView} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.NEW_BRANCH_APPLICATION_DETAILS} component={BranchApplicationDetails} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BRANCH_APPLICATION_REVIEW} component={BranchApplicationReview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BRANCH_APPLICATION_PAYMENT_CONFIRMATION} component={BranchApplicationPaymentConfirmation} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.SUPPORTING_DOCUMENTS} component={SupportingDocuments} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.TRUST_ACCOUNT} component={TrustAccount} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.SURETY_BOND} component={SuretyBond} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.APPLICATION_REVIEW} component={ApplicationReview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.APPLICATION_RENEWAL_REVIEW} component={AgencyApplicationRenewalReview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.COLLECTOR_BEFORE_START} component={CollectorBeforeStartConfirmation} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.COLLECTOR_DETAILS} component={CollectorDetails} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.AGENT_DETAILS + "/:agentApplicationId"} component={AgentDetails} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.ADDITIONAL_COLLECTOR_QUESTION} component={AdditionalCollectorQuestion} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.COLLECTOR_APPLICATION_REVIEW} component={CollectorApplicationReview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.CONFIRM_BEFORE_PAYMENT} component={ConfirmBeforePayment} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.COLLECTORS_REVIEW} component={CollectorsReview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.PAYMENT_PREVIEW} component={PaymentPreview} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.CONFIRM_APPLICATION_SUBMISSION} component={ConfirmApplicationSubmission} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.AGENCY_CHANGE_REQUEST} component={AgencyChangeRequest} />
          
          <Route exact={true} path={ROUTE_PATH.BLT_LOGIN} component={BLTLoginPage} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BLT_HOME} component={BLTHomePage} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BLT_REVIEW} component={BLTReviewPage} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BLT_CHANGE_REVIEW} component={BLTChangeReviewPage} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BLT_DECISION_SUMMARY} component={BLTDecisionSummaryPage} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BLT_LICENCE_INFORMATION} component={BLTLicenceInformationPage} />
          <PreloadedRoute exact={true} path={ROUTE_PATH.BLT_HOME_SEARCH} component={BLTHomeSearchPage} />
          <Route exact={true} path={ROUTE_PATH.LAUNCHPAGE} component={LaunchPage} />
        </Switch>
      </ScrollToTop>
    </div>
  );
}

export default App;
